import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import i from "./delegate.js";
import { warn as o } from "../../shared/warn.js";
import { defineComponent as d, getCurrentInstance as f, onMounted as u, onBeforeUnmount as a, renderSlot as m } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const c = d({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(s) {
    let n = !1;
    const r = f().proxy;
    function l(e) {
      const { onResize: t } = s;
      t !== void 0 && t(e);
    }
    u(() => {
      const e = r.$el;
      if (e === void 0) {
        o("resize-observer", "$el does not exist.");
        return;
      }
      if (e.nextElementSibling !== e.nextSibling && e.nodeType === 3 && e.nodeValue !== "") {
        o("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      e.nextElementSibling !== null && (i.registerHandler(e.nextElementSibling, l), n = !0);
    }), a(() => {
      n && i.unregisterHandler(r.$el.nextElementSibling);
    });
  },
  render() {
    return m(this.$slots, "default");
  }
});
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/resize-observer/src/VResizeObserver.js
// module id = 272
// module chunks = 67